import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {getLineItemSubscriptionFrequencyText} from '../../../../../../domain/utils/getLineItemSubscriptionFrequencyText';

export const TotalPrice = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  const shouldDisplayFrequency =
    lineItem.attributes.subscriptionInfo &&
    lineItem.attributes.subscriptionInfo.subscriptionSettings.billingCycles !== 1;

  const {t} = useTranslation();

  return (
    <div
      className={s.totalPrice}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      <div className={s.priceRow}>
        {shouldShowCrossedOutPriceOnLineItemLevel &&
          lineItem.pricing.breakdown.comparePrice?.formattedConvertedAmount && (
            <div data-hook={CartItemDataHook.ComparePriceOnLineItem} className={s.comparePrice}>
              {lineItem.pricing.breakdown.comparePriceByQuantity.formattedConvertedAmount}
            </div>
          )}
        <div className={s.totalPriceText}>{lineItem.pricing.totalPrice.formattedConvertedAmount}</div>
      </div>

      {shouldDisplayFrequency && (
        <div className={s.subscriptionFrequency} data-hook={CartItemDataHook.SubscriptionFrequency}>
          {getLineItemSubscriptionFrequencyText(t, lineItem.attributes.subscriptionInfo.subscriptionSettings)}
        </div>
      )}
    </div>
  );
};
